import { PopconfirmProps, Form, Popconfirm, Input } from '@pankod/refine-antd'

type PopDeleteConfirmWithValidate = {
  validateValue: string
  placeholder?: string
  errorMessage?: string
} & PopconfirmProps

type PopDeleteConfirmWithoutValidate = {
  validateValue?: never
  placeholder?: never
  errorMessage?: never
} & PopconfirmProps

export const PopDeleteConfirm = ({
  title,
  children,
  validateValue,
  placeholder,
  errorMessage,
  ...props
}: PopDeleteConfirmWithValidate | PopDeleteConfirmWithoutValidate) => {
  const [form] = Form.useForm()
  const textValue = Form.useWatch('text', form)

  if (!validateValue)
    return (
      <Popconfirm title={title} {...props}>
        {children}
      </Popconfirm>
    )

  return (
    <Popconfirm
      title={
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            text: '',
          }}
        >
          <Form.Item
            label={title}
            className="!mb-0"
            name="text"
            rules={[
              {
                validator(_, value) {
                  if (value !== validateValue) {
                    return Promise.reject(
                      errorMessage || 'Confirmation validation did not match',
                    )
                  }

                  return Promise.resolve()
                },
              },
            ]}
          >
            <Input autoComplete="off" placeholder={placeholder} />
          </Form.Item>
        </Form>
      }
      {...props}
      okButtonProps={{
        ...props.okButtonProps,
        disabled: textValue !== validateValue,
      }}
      onVisibleChange={(visible) => {
        if (visible) form.resetFields()
      }}
    >
      {children}
    </Popconfirm>
  )
}
